import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=1987d28d&scoped=true"
import script from "./Sound.vue?vue&type=script&lang=js"
export * from "./Sound.vue?vue&type=script&lang=js"
import style0 from "./Sound.vue?vue&type=style&index=0&id=1987d28d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987d28d",
  null
  
)

export default component.exports